import {
    GET_CARGAS_PREVIAS,
    POST_CARGAR_ARCHIVO,
    GET_INGRESO_PAGOS
} from '../types';


export default function cargaEmisionPagosCIAReducer(state = {}, action) {
    switch (action.type) {
        case GET_CARGAS_PREVIAS:
            return { ...state, ...action.payload }
        case POST_CARGAR_ARCHIVO:
            return { ...state, archivo: action.payload }
        case GET_INGRESO_PAGOS:
            return { ...state, ingresoPagos: action.payload }
        default:
            return state
    }
}